import React from "react";
import { Grid2 as Grid, Typography } from "@mui/material";
import { Item } from ".";
import { SearchResult } from "../../../shared/types";

export interface CollectionProps {
  searchResults: SearchResult[];
  handleSelect: (ein: string) => void;
}

export const Collection = ({
  searchResults,
  handleSelect,
}: CollectionProps): React.JSX.Element => {
  if (searchResults.length > 0) {
    return (
      <Grid size={{ xs: 12 }} container spacing={2}>
        {searchResults.map((searchResult: SearchResult) => {
          return (
            <Item
              ein={searchResult.ein}
              key={searchResult.ein}
              handleSelect={() => {
                handleSelect(searchResult.ein);
              }}
            />
          );
        })}
      </Grid>
    );
  } else {
    return (
      <Grid size={{ xs: 12 }} container spacing={2}>
        <Grid size={{ xs: 12 }}>
          <Typography variant="body1" component="div">
            We were unable to find any charities using your search criteria.
          </Typography>
        </Grid>
        <Grid size={{ xs: 12 }}>
          <Typography variant="body1" component="div">
            Charities that are registered with the IRS as a 501(c)(3) can be
            found in our database of over 1.8 million U.S. charities. If you
            don't see your favorite charities, search for them using the
            charity's legal name or EIN (tax ID number).
          </Typography>
        </Grid>
      </Grid>
    );
  }
};
